import styled from "styled-components";
import { Link } from "react-router-dom";
import colors from "../../utils/style/colors.tsx";

const CardContainer = styled(Link)`
    background-color: ${colors.white};
    border: solid 7px ${colors.black};
    border-radius: 20px;
    box-shadow: 7px 7px ${colors.black};
    overflow: hidden;
    cursor: pointer;
    text-decoration: none;
    color: ${colors.black};
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    height: 100%;

    &:hover {
        transform: translate(-5px, -5px);
        box-shadow: 12px 12px ${colors.black};
    }

    @media (max-width: 768px) {
        border: solid 5px ${colors.black};
        box-shadow: 5px 5px ${colors.black};

        &:hover {
            transform: translate(-3px, -3px);
            box-shadow: 8px 8px ${colors.black};
        }
    }
`;

const ImageWrapper = styled.div`
    width: 100%;
    height: 280px;
    overflow: hidden;
    background-color: ${colors.light_pink};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;

    @media (max-width: 768px) {
        height: 200px;
        padding: 15px;
    }
`;

const ProjectImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const ContentWrapper = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex-grow: 1;

    @media (max-width: 768px) {
        padding: 15px;
    }
`;

const ProjectTitle = styled.h3`
    font-family: "Archivo Black", sans-serif;
    font-size: 20px;
    margin: 0;
    color: ${colors.h1_red};

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

const ProjectDescription = styled.p`
    font-family: "Inter", sans-serif;
    font-size: 16px;
    margin: 0;
    color: ${colors.black};
    line-height: 1.4;

    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

const CategoryBadge = styled.span`
    display: inline-block;
    padding: 5px 15px;
    background-color: ${({ $category }) => 
        $category === "web" ? colors.dark_red : colors.pink};
    color: ${colors.white};
    border-radius: 15px;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 600;
    width: fit-content;

    @media (max-width: 768px) {
        font-size: 12px;
        padding: 4px 12px;
    }
`;

function ProjectCard({ project }) {
    return (
        <CardContainer to={`/projet/${project.slug}`}>
            <ImageWrapper>
                <ProjectImage src={project.image} alt={project.texte} />
            </ImageWrapper>
            <ContentWrapper>
                <CategoryBadge $category={project.category}>
                    {project.category === "web" ? "Développement Web" : "Design Graphique"}
                </CategoryBadge>
                <ProjectTitle>{project.texte}</ProjectTitle>
                <ProjectDescription>{project.description}</ProjectDescription>
            </ContentWrapper>
        </CardContainer>
    );
}

export default ProjectCard;
